import { useApiRole } from '../contexts/ApiContext';
import { ApiMemberRole } from '../openapi';

const rolePriority: Record<ApiMemberRole, number> = {
  OWNER: 5,
  ADMIN: 4,
  PAYER: 3,
  VIEWER: 2,
  MEMBER: 1,
};

export function useHasRole(target: ApiMemberRole) {
  const current = useApiRole();

  const targetPriority = rolePriority[target] ?? 0;
  const currentPriority = rolePriority[current] ?? 0;

  return currentPriority >= targetPriority;
}

export function useHasThreeDsAccess() {
  return useHasRole('ADMIN');
}
